'use strict';

import {element_exists} from "../../functions";
import {fnErrorMsg} from "../../jquery-functions-library";

export var fnDashReloadOnDemand = function () {

    var tableName = '#datatable-db-v2-all';

    if (!element_exists(tableName)) return false;

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

    var element = '.select_reload_on_demand';

    $(document).off('click', element);
    $(document).on('click', element, function (e) {
        e.preventDefault();

        var data_field_name = $(this).text();
        var class_color = $(this).attr('data-color');

        var parentBtn = $('[data-attachedUl=' + $(this).parent().attr('data-parent') + ']').find('.employee_field_button');
        var parentBtnClass = parentBtn.attr('data-color');

        parentBtn.attr('data-color', class_color);
        parentBtn.removeClass(parentBtnClass);
        parentBtn.addClass(class_color);
        parentBtn.html(data_field_name + '<div class="ripple-container"></div>');


        var value = $(this).data('value');
        var id = $(this).data('id');

        var self = $(this);

        $.ajax({
            type: 'POST',
            url: '/setReloadOnDemand',
            data: {company_id: id, reload_on_demand: value},
            success: function (response) {
                console.log(response);

                var interval = setInterval(function () {
                    $.ajax({
                        type: 'POST',
                        url: '/getReloadOnDemand',
                        data: {company_id: id},
                        success: function (response) {
                            console.log(response);

                            if (response.value !== value) {
                                clearInterval(interval);

                                // Get the data and modify it
                                var rowData = $(tableName).DataTable().row("#" + id).data();

                                rowData.services.reload_on_demand = response.value;

                                // Redraw the table
                                $(tableName).DataTable().row("#" + id).data(rowData).draw();
                            }
                        },
                        error: fnErrorMsg
                    });
                }, 15000);
            },
            error: fnErrorMsg
        });
    });
};